import { render, staticRenderFns } from "./LogsRecord.vue?vue&type=template&id=8efb63f4"
import script from "./LogsRecord.vue?vue&type=script&lang=js"
export * from "./LogsRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports